import { Injectable } from '@angular/core';
import { BaseService } from '../@base/base.service';
import { PageBanner } from '../models/banner/pageBanner';
import { Observable, Subject } from 'rxjs';
import { InterceptorSkipModalError } from '../interceptor/interceptor';


@Injectable({
  providedIn: 'root'
})
export class NewconService extends BaseService<any> {

  constructor() {
    super()
    this.path = "gateway/Newcon";
  }


  public getUrl(): Observable<any> {
    return this.http.get<any>(`${this.api}${this.path}/GetUrl`, {
      headers: {
        [InterceptorSkipModalError]: "true"
      }
    })
  }

}
